import { Component, OnInit, Input, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from '../../_services/constants.service';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-accountdebit',
  templateUrl: './accountdebit.component.html',
  styleUrls: ['./accountdebit.component.css', './custom_style.css', './boot-outline-btn.css']
})
export class AccountdebitComponent implements OnInit {
  mandate_history = false;
  sending_account_request = false;
  has_default_card = false;
  @Input('parentRouteId') parentRouteId: any;
  @Input('loan') loan: any;
  @Input('repayment') repayment: any;
  @Input('where') where = 'accountdebit';
  @Input('token') token: any;
  accounts: any;
  accounts_added = 0;
  is_done = '0';
  loading = false;
  account: any;
  sending_direct_request = false;
  PASSWORD = '';
  CHANNEL = '';
  checking_mandate_status = false;
  resending_link = false;
  cancelling_dd = false;
  loadingData = false;
  checking_instructions = false;
  records_found = false;
  history: any; public pay_opt = [
    { value: '1' },
    { value: '2' },
    { value: '3' }
  ]
  state: any;
  link:any;
  payment = { PAY_WITH: '0', LENDER_ACCOUNT_ID: 0, SECURITY_QUESTION_ANSWER: 0, REQUEST_ID: 0, PAYMENT_DATE: '', AMOUNT_TO_PAY: '0', PAYMENT_OPTION: '1' };
  @Input('sending_instruction') sending_instruction = false;
  loading_ = false;
  constructor(private toastr: ToastrService, private http: HttpClient,
    private constant: ConstantsService,
    public operationsService: OperationsService, public loansService: LoansService) { }

  ngOnInit() {
    this.sending_instruction = false;
    this.checking_mandate_status = false;
    return this.getAccounts();

  }
  requestAccount() {
    this.loading = true;
    this.loading = false;
    this.is_done = '1';
    this.operationsService.sendAccountConfirmationRequest(this.token, this.parentRouteId);
  }
  sendAccountRequest() {
    this.sending_account_request = !this.sending_account_request;
    this.sending_direct_request = false;  
    this.resending_link = false;
    this.cancelling_dd = false;
  }
  linkGenerated(data){ 
    this.link = data.url;
  }
  getAccounts() {
    this.loadingData = true;
    return this.http.post<any>(`${this.constant.read('api_loan')}loan/accounts`, {
      request_id: this.parentRouteId,
      token: this.token
    }).subscribe(response => {
      this.loadingData = false;
      this.accounts_added = response.count;
      this.accounts = response.data;
      if (response.count == '0') {
        this.has_default_card = false;
        this.sending_account_request = true;

      } else {
        this.account = response.data[0];
      }
      this.loansService.getRepaymentData(this.token, this.parentRouteId)
      .subscribe(customers => {
        this.state = customers;
        this.payment.REQUEST_ID = this.parentRouteId;
        this.payment.PAYMENT_OPTION = this.pay_opt[0].value;
        if(customers.BOOKED == '1'){
          this.sending_instruction=true;
        }
      });
    }, error => {
    });
  }
  changeTheDefaultAccount(event) {
    this.sending_direct_request = false;
    this.sending_account_request = false;
    this.account = event.account_card;
    this.has_default_card = true;
    this.resending_link = false;
    this.cancelling_dd = false;
  }
  checkDirectDebitStatus(event) {
    this.checking_mandate_status = true;
    this.sending_direct_request = false;
    this.sending_account_request = false;
    this.resending_link = false;
    this.cancelling_dd = false;
  }
  cancelDirectDebit(event) {
    this.cancelling_dd = true;
    this.sending_direct_request = false;
    this.sending_account_request = false;
    this.checking_mandate_status = false;
    this.resending_link = false;
    //this.cancelling_dd = false;
  }
  setupDirectDebit(event) {
    this.sending_account_request = false;
    this.is_done = '0';
    this.sending_direct_request = true;
    this.checking_mandate_status = false;
    this.resending_link = false;
    this.cancelling_dd = false;
  } 
  resendingLink(event) {
    this.sending_account_request = false;
    this.sending_direct_request = false;
    this.checking_mandate_status = false;
    this.resending_link = true;
    this.cancelling_dd = false;
  } 
  sendForDirectDebitOnAccount() {
    this.loading = true;
    this.loansService.sendRequestForDirectDebitOnAccount(this.token, this.parentRouteId, this.account, this.PASSWORD, 1)
      .subscribe(data => {
        this.loading = false;
        if (data.status) {
          this.is_done = '1';
          this.showSuccess('An email has been sent to the borrower to complete the mandate set up');
          this.cancelling_dd = false;
          this.sending_direct_request = false;
          this.sending_account_request = false;
          this.checking_mandate_status = false;
          this.resending_link = false;
          this.cancelling_dd = false;
          this.getAccounts();
        } else {
          this.showError(data.message);
        }
      });
  }
  sendForDirectDebitStatus() {
    this.loading = true;
    this.loansService.sendForDirectDebitStatus(this.token, this.parentRouteId, this.account)
      .subscribe(data => {
        this.loading = false;

        this.is_done = '1';

        if (data.isActive == true) {
          this.showSuccess('Mandate Is Active');
        } else {
          this.showError("Mandate is not active");
        }
      });

  }
  sendForResendDirectDebitStatus() {
    this.loading = true;
    this.loansService.sendForResendDirectDebitStatus(this.token, this.parentRouteId, this.account)
      .subscribe(data => {
        this.loading = false;

        this.is_done = '1';

        if (data.isActive == true) {
          this.showSuccess('Mandate link has been resent');
        }
      });
  }
  sendForCancelDirectDebitStatus() {
    this.loading = true;
    this.loansService.sendForCancelDirectDebitStatus(this.token, this.parentRouteId, this.account)
      .subscribe(data => {
        this.loading = false;

        this.is_done = '1';

        if (data.isActive == true) {
          this.showSuccess('Mandate Is Cancelled');
        }
      });
  }
  showSuccess(msg) {
    this.toastr.success(msg);
  }
  showError(msg) {
    this.toastr.error(msg);
  } 
  showMandateHistory(){

  }
  debitMandateHistory(loan, acc) {
    this.checking_instructions = true;
    this.mandate_history = true;
    this.operationsService.getMandateTransactionHistory(this.token, this.loan, this.account)
      .subscribe(data => {
        this.checking_instructions = false;
        if (data.statuscode == "00") {
          this.records_found = true;
          this.history = data.data.data.paymentDetails;
        } else {
          this.records_found = false;
          this.showError("No record found");
        }
      });
  }
  sendDebitInstruction(){
    this.sending_instruction = true
  }
  doSendDebitInstruction(): void {
    
    this.loading_ = true;
    this.operationsService.sendDebitInstruction_(this.token, this.payment, this.account, this.repayment)
      .subscribe(status => {
        this.loading_ = false;
        if (status.status == true) {
          this.showSuccess(status.message)
           
        } else {
          this.showError(status.message);
        }



      });
  }
}
